// Barra de ações em lote — aparece quando há lançamentos selecionados.
// Dispara `onAbrirAcao` com a action e payload inicial; o pai resolve o modal.
// Excluir tem path próprio com modal de confirmação inline.
// Extraído de FinanceiroContasPagar.tsx em 2026-05-23 (frontend wave 3B).
import axios from 'axios';
import { Button, Dropdown, Space, Typography, App as AntApp } from 'antd';
import {
  CheckCircleOutlined, EditOutlined, DeleteOutlined, RollbackOutlined,
  DollarOutlined,
} from '@ant-design/icons';
import { API_URL } from '../../config';
import { getToken } from './utils';

const { Text } = Typography;

export interface AcaoLoteFormState {
  action: string;
  payload: any;
}

export function BarraAcoesLote({ selecionados, itemsSelecionados, onAbrirAcao,
  onAposExcluir, limparSelecao }: {
  selecionados: Set<string>;
  itemsSelecionados: () => Array<{ id: string; origem: string; _fonte?: string }>;
  onAbrirAcao: (state: AcaoLoteFormState) => void;
  onAposExcluir: () => void; // recarrega lista
  limparSelecao: () => void;
}) {
  const { message, modal } = AntApp.useApp();

  function pedirConfirmacaoExcluir() {
    modal.confirm({
      title: `Excluir ${selecionados.size} lançamento${selecionados.size !== 1 ? 's' : ''}?`,
      content: 'Operação irreversível. Pré-cut-over não será excluído.',
      okText: 'Excluir tudo', okType: 'danger',
      onOk: async () => {
        const items = itemsSelecionados();
        if (!items.length) return;
        try {
          const token = await getToken();
          const r = await axios.post(`${API_URL}/contas-pagar/bulk`,
            { items, action: 'excluir', payload: {} },
            { headers: { Authorization: token } });
          const d = r.data.body ? JSON.parse(r.data.body) : r.data;
          const okN = (d?.sucesso || []).length;
          const errN = (d?.erros || []).length;
          if (errN === 0) message.success(`${okN} excluído${okN !== 1 ? 's' : ''}.`);
          else message.warning(`${okN} ok, ${errN} com erro: ${d.erros[0]?.erro || ''}`);
          limparSelecao();
          onAposExcluir();
        } catch (e: any) {
          message.error('Erro: ' + (e.response?.data?.error || e.message));
        }
      },
    });
  }

  return (
    <div style={{
      padding: '10px 14px', background: '#E8EEFF', borderRadius: 6,
      marginBottom: 10, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: 12, flexWrap: 'wrap',
    }}>
      <Text strong style={{ color: '#020D7F', fontSize: 12 }}>
        {selecionados.size} registro{selecionados.size !== 1 ? 's' : ''} selecionado{selecionados.size !== 1 ? 's' : ''}
      </Text>
      <Space wrap>
        <Dropdown trigger={['click']} placement="bottomRight"
          menu={{
            items: [
              { key: 'pago', icon: <CheckCircleOutlined />, label: 'Definir como pago',
                onClick: () => onAbrirAcao({ action: 'marcar_pago', payload: { data_pagamento: new Date().toISOString().slice(0, 10) } }) },
              { key: 'aberto', icon: <RollbackOutlined />, label: 'Definir como em aberto',
                onClick: () => onAbrirAcao({ action: 'marcar_em_aberto', payload: {} }) },
              { key: 'agendar', icon: <DollarOutlined />, label: 'Marcar como agendado',
                onClick: () => onAbrirAcao({ action: 'marcar_agendado', payload: {} }) },
              { key: 'desagendar', label: 'Desmarcar como agendado',
                onClick: () => onAbrirAcao({ action: 'desmarcar_agendado', payload: {} }) },
              { type: 'divider' },
              { key: 'venc', icon: <EditOutlined />, label: 'Alterar vencimento',
                onClick: () => onAbrirAcao({ action: 'alterar_vencimento', payload: { data_vencimento: '' } }) },
              { key: 'valor', icon: <EditOutlined />, label: 'Alterar valor',
                onClick: () => onAbrirAcao({ action: 'alterar_valor', payload: { valor: '' } }) },
              { key: 'conta', icon: <EditOutlined />, label: 'Alterar conta',
                onClick: () => onAbrirAcao({ action: 'alterar_conta', payload: { conta_financeira_ca: '' } }) },
              { type: 'divider' },
              { key: 'editar_campos', icon: <EditOutlined />, label: 'Editar (múltiplos campos)',
                onClick: () => onAbrirAcao({
                  action: 'editar_campos',
                  payload: { /* preenchido pelos toggles do modal */ }
                }) },
              { type: 'divider' },
              { key: 'excluir', icon: <DeleteOutlined />, label: 'Excluir', danger: true,
                onClick: pedirConfirmacaoExcluir },
            ],
          }}>
          <Button type="primary">Ações em lote ▼</Button>
        </Dropdown>
        <Button onClick={limparSelecao}>Limpar seleção</Button>
      </Space>
    </div>
  );
}
